import React from 'react';

import classNames from 'classnames';

import {isPDPRevamp} from 'constants/recommendation';

import {ProductStatusComponent, ProductStatusContainer, ProductStatusLabel} from './styles';
import {ProductCardVariant, ProductStatusProps} from '../product-discontinued-status/types';

const ProductStatus: React.FC<ProductStatusProps> = ({status, isPDP, productCardVariant}) => {
  return (
    <ProductStatusContainer
      className={classNames({
        pdp: isPDP,
        pdpRevamp: isPDPRevamp,
        compact: productCardVariant === ProductCardVariant.COMPACT,
        ads: productCardVariant === ProductCardVariant.ADS
      })}
    >
      <ProductStatusComponent>
        <ProductStatusLabel>{status}</ProductStatusLabel>
      </ProductStatusComponent>
    </ProductStatusContainer>
  );
};

export default ProductStatus;
